<template>
  <ol v-if="showBreadCrumb" class="breadcrumb">
    <li class="breadcrumb-item" v-for="(item, index) in items" :key="index">
      <span class="active" v-if="isLast(index)">{{ item.name }}</span>
      <router-link :to="item.to" v-else>{{ item.name }}</router-link>
    </li>
  </ol>
</template>

<script>
/* eslint-disable */
export default {
  computed: {
    items() {
      return this.$store.getters.breadcrumbItems;
    },
    showBreadCrumb() {
      return this.$store.getters.useBreadcrumb;
    },
  },
  methods: {
    isLast (index) {
      return index === this.items.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        return item.meta && item.meta.label
      }
      if (item.name) {
        return item.name
      }
      return item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue